import moment from "moment-timezone";
import React, { useEffect, useState } from "react";

import { convertToTwoDigits, convertUtcToLocalTimeCustomFormat } from "../../../utils/utils";
import { AppLoader } from "../../../shared/components/Loader";
import { runAssessmentClientList } from "../../../shared/settings/apiConfig";

import './TakeAssessmentList.scss';
import DataListView from "./DataListView";
import { Form, Spinner } from "react-bootstrap";

const RUN_STATUS = {
    'Not Started': "Start",
    'In Progress': "Resume",
    'Completed': "Completed",
    'Expired': "Expired",
    'Future': "Future"
};
const RUN_STATUS_IMG = {
    'Not Started': "NOTSTARTED",
    'In Progress': "INPROGRESS",
    'Completed': "COMPLETED",
    'Expired': "EXPIRED",
    'Future': 'FUTURE'
};
const BOREDER_COLOR = {
    'Not Started': "border-info",
    'In Progress': "border-warning",
    'Completed': "border-success",
    'Expired': "border-danger",
    'Future': "border-primary"
};
export const getDurationDiff = (startTime, endTime) => {
    if (startTime && endTime) {
        const duration = moment.duration(moment.utc(endTime, 'YYYY-MM-DD HH:mm:ss').diff(moment.utc(startTime, 'YYYY-MM-DD HH:mm:ss')));
        return `${convertToTwoDigits(duration.hours())}:${convertToTwoDigits(duration.minutes())}:${convertToTwoDigits(duration.seconds())}`;
    }

    return '- - -';
};
export const TakeAssessmentList = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [overdueChecked, setOverdueChecked] = useState(false);
  const [completedChecked, setCompletedChecked] = useState(false);
  const [hasData, setHasData] = useState(true);
  const [hasOverdueData, setHasOverdueData] = useState(true);

    const now = moment().utc().format("YYYY-MM-DD HH:mm:ss");

    const navigateToTakeAssessmentScreen = (runstatus, assessmentData) => {
        if (runstatus == "Not Started" || runstatus == "In Progress") {
            props.history.push(`/take-assessments/${assessmentData.id}`, { assessmentItem: assessmentData });
        }
    };

    const renderInnerUI = (assessmentData) => {
        if (!assessmentData) return null;
        let runstatus = (assessmentData.runstatus !== "Completed" && moment.utc(assessmentData.expirydate).isSameOrBefore(moment.utc())) ? "Expired" : moment.utc(assessmentData.scheduleddate || assessmentData.rundate).isAfter(moment.utc()) ? "Future" : assessmentData.runstatus;
        return (
            <div className="assessment-item d-flex m-1 p-1 bottom-shadow">
                <div className={`left d-flex py-1 ps-2 justify-content-center flex-column ${BOREDER_COLOR[runstatus]}`} style={{ borderLeft: "0.7rem solid" }} >
                    <div>Start - {convertUtcToLocalTimeCustomFormat(assessmentData.scheduleddate ? assessmentData.scheduleddate : assessmentData.rundate, 'ddd' + " " + 'DD MMM YYYY' + " " + 'hh:mm a')}</div>
                    <div>End - {convertUtcToLocalTimeCustomFormat(assessmentData.expirydate, 'ddd' + " " + 'DD MMM YYYY' + " " + 'hh:mm a')}</div>
                    {/* <div>{convertUtcToLocalTimeCustomFormat(assessmentData.starttime, 'DD MMM YYYY')}</div>
                    <div>{convertUtcToLocalTimeCustomFormat(assessmentData.starttime, 'hh:mm a')}</div> */}
                </div>
                <div className="w-100 px-3 d-flex flex-column gap-2" style={{ borderLeft: "1px solid #dee2e6", borderRight: "1px solid #dee2e6" }}>
                    <div className="d-flex flex-column gap-1">
                        <div className="font-weight-bold text-grey h5 m-0">{assessmentData.assessmentname ? assessmentData.assessmentname : "---"}</div>
                        <div className="">{assessmentData.subtitle || "- - -"}</div>
                    </div>
                    <div className="d-flex ">
                        <div className="d-flex flex-column gap-2 w-90">
                            <div className="d-flex gap-2" >
                                <div className="font-weight-bold">Subject/Topic:</div>
                                <div>{assessmentData.subjectname || '- - -'}</div>
                            </div>
                            <div className="d-flex gap-2" >
                                <div className="font-weight-bold">Duration:</div>
                                {assessmentData.starttime && assessmentData.endtime ? <div>{getDurationDiff(assessmentData?.starttime, assessmentData?.endtime)}</div> : '- - -' }
                            </div>
                            <div className="d-flex gap-2" >
                                <div className="font-weight-bold">Attempt:</div>
                                <div>{assessmentData.attempt || '- - -'}</div>
                            </div>
                        </div>

                        {/* <div className="w-10 d-flex justify-content-end">
                            {assessmentData.ispublished ? <span role="button" className="text-s action-link font-weight-bold">Know More</span> : null}
                        </div>
                        <div className="w-10 d-flex justify-content-end">
                            {assessmentData.ispublished ? <span role="button" className="text-s action-link font-weight-bold" onClick={() => { props.history.push(`/scheduler/client/view/result/${assessmentData.resultid}`); }}>Preview</span> : null}
                        </div> */}
                        <div className="w-10 d-flex justify-content-end">
                            {
                                assessmentData.resultstatus && assessmentData.resultstatus !== 'Completed' ?
                                (<div className="d-flex align-items-center gap-2 text-warning">
                                    <Spinner />
                                    <span className="">Processing</span>
                                </div>) : 
                                (
                                    assessmentData.ispublished && 
                                    <div>
                                        <span role="button" className="text-s action-link font-weight-bold" onClick={() => { props.history.push(`/scheduler/client/view/result/${assessmentData.resultid}`); }}>View Results</span>
                                    </div>
                                )

                            }
                        </div>
                    </div>

                </div>
                <div className="right status-badge" role={runstatus == "Not Started" || runstatus == "In Progress" ? "button" : "banner"} onClick={() => { navigateToTakeAssessmentScreen(runstatus, assessmentData); }}>
                    <img className="m-2 status-badge-img" src={`${process.env.PUBLIC_URL}/static/images/${RUN_STATUS_IMG[runstatus]}.png`} alt={"runstatus"} />
                    <label>{RUN_STATUS[runstatus]}</label>
                </div>
            </div>
        );
    };

    const [config, setConfig] = useState({
        name: 'All Assessments',
        url: runAssessmentClientList,
        renderUI: renderInnerUI,
        pagination: true,
        payload: {
            filter: [
                { field: "runtype", value: 3, op: "!=", join: "AND" },
                { field: "runstatus", value: [["Pending"]], op: "!=", join: "AND" }
                // { field: "scheduledate", value: now, op: ">", join: "OR" }
            ],
            sort: [{ field: "id", direction: "desc" }]
        },
        onDataLoad: (data) => setHasData(data && data.length > 0),
    });

    const [overdueConfig, setOverdueConfig] = useState({
        name: 'Overdue Assessments',
        url: runAssessmentClientList,
        renderUI: renderInnerUI,
        pagination: true,
        payload: {
            filter: [
                { field: "runtype", value: 3, op: "!=", join: "AND" },
                { field: "expirydate", value: now, op: "<", join: "AND" },
                { field: "runstatus", value: [['Not Started', 'Pending']], op: "IN", join: "AND" },
            ],
            sort: [{ field: "id", direction: "desc" }]
        },
        onDataLoad: (data) => setHasOverdueData(data && data.length > 0),
    });

    useEffect(() => {
        if (overdueChecked) {
            setConfig(prev => ({
                ...prev,
                payload: {
                    ...prev.payload,
                    filter: [{ field: "runstatus", value: "Completed", op: "=", join: "AND" }]
                }
            }));
            setOverdueConfig(null);
        } else if (completedChecked) {
            setConfig(prev => ({
                ...prev,
                payload: {
                    ...prev.payload,
                    filter: [
                        { field: "expirydate", value: now, op: "<", join: "AND"},
                        {field: "runstatus", value: "Not Started", op: "=", join: "AND"}
                    ]
                }
            }));
            setOverdueConfig(null);
        }
    }, [overdueChecked, completedChecked]);

    const checkboxChange = (event, type) => {
        if (type === "overdue") {
            setOverdueChecked(event.target.checked);
            setCompletedChecked(false);
        } else if (type === "completed") {
            setCompletedChecked(event.target.checked);
            setOverdueChecked(false);
        }
    };

    return (
        <div className="take-assessment-list-container p-3">
            <div className="w-50 d-flex align-items-center">
                <img className="ms-2" width="25px" src={`${process.env.PUBLIC_URL}/static/images/menu.png`} alt="menu"/>
                <span className="screen-head my-1">Active Assessments</span>
            </div>

            {isLoading ? (
                <AppLoader />
            ) : (
                <div>
                    <div className="ms-2 d-flex align-items-center checkbox-mobile gap-3">
                        <Form.Check
                            custom
                            className="d-flex gap-1 align-items-center"
                            type="checkbox"
                            label="Hide Overdue"
                            value="overdue"
                            checked={overdueChecked}
                            onChange={(event) => checkboxChange(event, "overdue")}
                        />
                        <Form.Check
                            custom
                            className="d-flex gap-1 align-items-center"
                            type="checkbox"
                            label="Hide Completed"
                            value="completed"
                            checked={completedChecked}
                            onChange={(event) => checkboxChange(event, "completed")}
                        />
                    </div>

            <div className="mt-3">
                {config && !hasData ? (
                    <div className="text-center py-4">No assessments found</div>
                ) : (
                    config && <DataListView config={config} />
                )}

                {overdueConfig && (
                    <div className="mt-4">
                        <DataListView config={overdueConfig} />
                    </div>
                )}
            </div>
        </div>
      )}
    </div>
  );
};
